import { apiRequest } from "../api";

export const getAdmins = (query: string) => apiRequest(`/admins?${query}`, "GET");
export const getAdmin = (id: string) => apiRequest(`/admins/${id}`, "GET");
export const createAdmin = (payload: unknown) => apiRequest("/admins", "POST", payload);
export const updateAdmin = (id: string, payload: unknown) =>
  apiRequest(`/admins/${id}`, "PUT", payload);
export const deleteAdmin = (id: string) => apiRequest(`/admins/${id}`, "DELETE");
